
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/auth/register",
      function () {
        return require("private-next-pages/en/auth/register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/auth/register"])
      });
    }
  